import { render, staticRenderFns } from "./mo-functional-header-wrapper.html?vue&type=template&id=4bc53502&scoped=true&external"
import script from "./mo-functional-header-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-functional-header-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-functional-header-wrapper.scss?vue&type=style&index=0&id=4bc53502&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc53502",
  null
  
)

export default component.exports